import { makeAutoObservable, action, observable, computed } from "mobx";
import { eq } from "lodash";
import { Screens } from "../constants";

export class RouteStore {
  routeName = "";

  constructor() {
    makeAutoObservable(this, {
      routeName: observable,
      setRouteName: action,
      getRouteName: computed,
      homeActive: computed,
      searchActive: computed,
      notificationActive: computed,
      profileActive: computed,
    });
  }

  setRouteName(newRouteName) {
    this.routeName = newRouteName;
  }

  get getRouteName() {
    return this.routeName;
  }

  get homeActive() {
    return eq(this.routeName, Screens.HOME);
  }

  get searchActive() {
    return eq(this.routeName, Screens.SEARCH);
  }

  get notificationActive() {
    return eq(this.routeName, Screens.NOTIFICATIONS);
  }

  get profileActive() {
    return eq(this.routeName, Screens.PROFILE);
  }
}

export default RouteStore;
